import React from "react";
import '../../../styles/components/onboarding/info/feedback-page.scss';
import WebPImage from "../../common/WebPImage";
import {onboardingImagesSource} from "../../../config/config";
import {WhenDeviceTypeDesktop} from "../../conditional/device/type/WhenDeviceTypeDesktop";
export default function FeedbackPage() {
  return (
    <div className="feedback-page">

      <WhenDeviceTypeDesktop>
        <WebPImage  width={640} height={644} src={onboardingImagesSource.scorePopup} additionalClassName={"slide-image slide-center"} />
      </WhenDeviceTypeDesktop>
      <WhenDeviceTypeDesktop not>
      </WhenDeviceTypeDesktop>
      <div className="top">
        <img width={768} height={244} src={onboardingImagesSource.outlineKeyboard} loading={"eager"} className={"outline-keyboard"}/>
        <WebPImage width={640} height={644} src={onboardingImagesSource.scorePopup} additionalClassName={"score-popup"} alt={"Playing accuracy score with points won"}/>
      </div>

      <div className="content">
        <div className="content-header">Get real-time feedback and&nbsp;scoring</div>
        <div className="info-text">Play with instant feedback. Using your device&apos;s microphone or a keyboard connected via USB or MIDI, you&apos;ll get accuracy scores as you play so you can track your progress, strengthen skills, earn rewards, and level up.</div>
      </div>
    </div>
  );
}